import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=528dc4f1&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=528dc4f1&prod&scoped=true&lang=css"
import style1 from "./BlankLayout.vue?vue&type=style&index=1&id=528dc4f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528dc4f1",
  null
  
)

export default component.exports